import { FilterOperator as r, FilterType as s } from "./filters.js";
const o = (e) => e.replaceAll("\\", "\\\\").replaceAll("%", "\\%").replaceAll("_", "\\_"), a = (e) => e.replaceAll("\\%", "%").replaceAll("\\_", "_").replaceAll("\\\\", "\\"), l = (e) => {
  switch (e.predicate.operator) {
    case r.IN:
      return e.predicate.value.values.join(", ");
    case r.Like: {
      const { pattern: t } = e.predicate.value;
      return n(t) ? a(t.substring(1, t.length - 1)) : i(t) ? a(t.substring(0, t.length - 1)) : a(t.substring(1, t.length));
    }
    case r.Match:
      return a(e.predicate.value.pattern);
    case r.BETWEEN:
      return "";
    case r.LT:
    case r.LTE:
    case r.GT:
    case r.EQ:
    case r.GTE:
      return "";
    default:
      return e.predicate;
  }
}, h = (e) => {
  try {
    return RegExp(e), !0;
  } catch {
    return !1;
  }
}, d = (e) => {
  switch (e.predicate.operator) {
    case r.IN:
      return e.predicate.value.values.length === 0;
    case r.Like:
    case r.Match:
      return !e.predicate.value.pattern.replaceAll("%", "").trim();
    case r.BETWEEN:
      return e.predicate.value.maxInclusive === void 0 || e.predicate.value.minInclusive === void 0;
    case r.GT:
    case r.EQ:
    case r.GTE:
    case r.LTE:
    case r.LT:
      return e.predicate.value.value === null || e.predicate.value.value === void 0;
    default:
      return e;
  }
}, n = (e) => e.startsWith("%") && e.endsWith("%") && !(e.startsWith("\\%") || e.endsWith("\\%")), p = (e) => e.startsWith("%") && !e.startsWith("\\%"), i = (e) => e.endsWith("%") && !e.endsWith("\\%"), v = (e, t) => {
  switch (e.type) {
    case s.dimension:
      return t;
    case s.metric:
      return e.reference.asPercentage ? t === void 0 ? t ?? void 0 : Number(t) * 100 : t;
    default:
      return e;
  }
}, E = (e, t) => {
  switch (e.type) {
    case s.dimension:
      return t;
    case s.metric:
      return e.reference.asPercentage ? t === void 0 ? t ?? void 0 : t / 100 : t;
    default:
      return e;
  }
};
export {
  o as escapePattern,
  v as formatFilterValueToHumanReadable,
  E as formatFilterValueToLego,
  l as getFilterValue,
  p as isEndWithPattern,
  d as isFilterEmpty,
  n as isIncludePattern,
  h as isRegexValid,
  i as isStartWithPattern,
  a as unescapePattern
};
//# sourceMappingURL=utils.js.map
